module.exports = __webpack_public_path__ + "media/images/photo/Agriculture/slider3-3ab3f8557d863ab02e63c65e6d6c1d7c.png";